// External Dependencies:
import React from 'react'

class ImageOverlay extends React.Component {
	render() {
		let { imageData } = this.props
		let className = 'ideal-image-overlay'
		let style = {}

		// Calculate CSS percentages to focus on the focal point:
		if ( imageData.overlay_opacity ) {
			style.opacity = imageData.overlay_opacity
		}

		return (
			<div className={ className } style={ style } />
		)
	}
}

export default ImageOverlay
